import { ThunkDispatch } from "redux-thunk";

import CreateApiModule from "@/redux/create-api-module";
import { IState, TApiAction, TExtraThunkArgs } from "@/redux/store.types";
import { Config } from "@/utils/config.utils";

import BoxCountReducer from "./boxCount.reducer";
import { $BoxCountModuleName } from "./boxCount.types";

const { actions } = CreateApiModule(
    $BoxCountModuleName,
    ({ url }) => `${url}`,
    {
        reducer: BoxCountReducer
    }
);

export const clear = actions.clear;

export const load =
    (sku: string, force: boolean = false) =>
    (dispatch: ThunkDispatch<IState, TExtraThunkArgs, TApiAction>) => {
        return dispatch(
            actions.load(
                {
                    path: {
                        url: `/productservice/${Config.general.basestore}/box/${sku}/count`
                    }
                },
                "GET",
                force,
                {
                    discriminator: sku
                }
            )
        );
    };

export const refetch = actions.refetch;
